import { Console } from "@/shared/lib/console";
import { __ } from "@/shared/ui";
import { BmMask } from "./mask";

export class BmFormat {
	public static formatFunctions: Record<string, (value: any) => string> = {
		ft: (value) => `${BmMask.mask(value, "000")} ${__("Ft")}`,
		"000": (value) => BmMask.mask(value, "000"),
		HUF: (value) => `${BmMask.mask(value, "000")} ${__("HUF")}`,
		"m ft": (value) => `${BmMask.mask(value, "000")} ${__("m Ft")}`,
		"+ft": (value) => `${BmMask.mask(value, "+000")} ${__("Ft")}`,
		"0,00 ft": (value) => `${BmMask.mask(value, "0,00")} ${__("Ft")}`,
		"millió ft": (value) => `${BmMask.mask(value, "000")} ${__("millió Ft")}`,
		"%": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${(newValue * 100).toFixed(2)}%`;
		},
		"+%": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			let output = `${(newValue * 100).toFixed(2)}%`;

			if (newValue >= 0) {
				output = `+${newValue}`;
			}

			return output;
		},
		"0.00%": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${(newValue * 100).toFixed(1)}%`;
		},
		"0%": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${newValue * 100}%`;
		},
		"100%": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${Number(newValue.toFixed(2))}%`;
		},
		"0": (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${newValue}`;
		},
		"Y.m.": (value) => `${value.split("-").slice(0, 2).join(". ")}.`,
		"Y.m.d.": (value) => `${value.split("-").slice(0, 3).join(". ")}.`,
		date: (value) => {
			if (typeof value === "string") {
				const [date, time] = value.split("T", 2);
				let output = "";

				if (typeof date === "string") {
					output = `${date.replace(/[^\d]+/g, ".")}.`;
				}

				if (typeof time === "string") {
					if (typeof date === "string") {
						output += " ";
					}
					output += time.split(":").slice(0, 2).join(":");
				}

				return output;
			}
		},
		loangoal: (value) => {
			switch (value) {
				case "BOVITES":
					return __("Bővítés");
				case "EPITES":
					return __("Építés");
				case "FELUJITAS":
					return __("Felújítás");
				case "HASZNALT_LAKAS":
					return __("Használt lakás vásárlás");
				case "HITELKIVALTAS":
					return __("Hitelkiváltás (lakáscélú)");
				case "KORSZERUSITES":
					return __("Korszerűsítés");
				case "SZAB_FEL":
					return __("Szabad felhasználás");
				case "UJ_LAKAS":
					return __("Új lakás vásárlás");
				// SZK szekció
				case "GEPJARMU_VASARLAS":
					return __("Gépjármű vásárlás");
				case "ENERGETIKAI_KORSZERUSITES":
					return __("Energetikai korszerűsítés");
				case "LAKASFELUJITAS":
					return __("Lakásfelújítás");
				case "LAKASVASARLAS":
					return __("Lakásvásárlás");
				case "SAJAT_BANKI_HITELKIVALTAS":
					return __("Saját banki hitelkiváltás");
				case "IDEGEN_BANKI_HITELKIVALTAS":
					return __("Idegen banki hitelkiváltás");
				case "SZABAD_FELHASZNALAS":
					return __("Szabad felhasználás");

				// NHP
				case "BUYING_PROPERTY":
					return __("Telephely vásárlás, bővítés");
				case "SELA_R_ESTATE":
					return __("Szálloda, iroda, lakóingatlan fejlesztés");
				case "BUYING_MACHINE":
					return __("Gép, berendezés vásárlása");
				case "BUYING_VEHICLE":
					return __("Haszongépjármű vásárlás");
				case "BUYING_PERSONAL_VEHICLE":
					return __("Személygépjármű vásárlás");
				case "STOCK_FINANCING":
					return __("Működés finanszírozása (vevő, készlet…stb.)");
				case "LOAN_REFINANCING":
					return __("Folyószámlahitel");

				//UJ SZÉCHENYI
				case "SAVING_WORKPLACE":
					return __("Munkahelyek megtartása");
				case "DAILY_OPERATION":
					return __("Napi működés biztosítása");
				case "ACQUISITIONS_FINANCING":
					return __("Forgóeszköz beszerzések / igénybe vett szolgáltatások finanszírozása");
				case "INTANGIBLE_ACQUISITIONS":
					return __("Immateriális javak beszerzése");
				case "PROPERTY_ACTIVITIES":
					return __("Ingatlan építése, vásárlása, fejlesztése");
				case "STOCK_FINANCING":
					return __("Új vagy használt gép berendezés, egyéb tárgyi eszközök beszerzése");
				case "COMPANY_ACQUISITION":
					return __("Üzletrész/ tulajdonrész vásárlása");
				case "LOAN_REFINANCING":
					return __("Hitelkiváltás");

				default:
					return __("Egyéb");
			}
		},
		interestPeriods: (value) => {
			switch (value) {
				case "FIX":
					return __("Végig fix");
				case "THREE_YEAR":
					return __("3 év");
				case "ONE_YEAR":
					return __("1 év");
				case "THREE_MONTH":
					return __("3 hónap");
				default:
					return __("Egyéb");
			}
		},
		// SZK moratórium
		interest: (value: string) => {
			switch (value) {
				case "THREE_MONTH":
					return "3 hónapig";
				case "SIX_MONTH":
					return "6 hónapig";
				case "ONE_YEAR":
					return "1 évig";
				case "THREE_YEAR":
					return "3 évig";
				case "FIVE_YEAR":
					return "5 évig";
				case "TEN_YEAR":
					return "10 évig";
				case "FIX":
					return "Végig";
				default:
					return "Egyéb";
			}
		},
		év: (value) => {
			const newValue = Number(value);

			if (isNaN(newValue)) {
				return "-";
			}

			return `${newValue} ${__("év")}`;
		},
		bool: (value) => (String(value) === "true" ? __("igen") : __("nem")),
		incomeMode: (value) => {
			switch (value) {
				case "TO_BANKACCOUNT":
					return __("Bankszámlára");
				default:
					return __("Készpénzben");
			}
		},
	};

	public static addFormat(format: string, f: (value: string) => string): void {
		BmFormat.formatFunctions[format] = f;
	}
}

// Php-s sprintf fv megfelelője
export function sprintf(format, ...args) {
	let i = 0;

	return format.replace(/%s/g, () => args[i++]);
}

/**
 * Szöveg formázás
 *
 * @param  {String} value	Formázandó szöveg
 * @param  {String} mask	Formázás megnevezése
 * @return {String}			Formázott szöveg
 */
export function formatText(value: string | number | boolean, mask: string): string {
	if (value === "-") {
		return value;
	}

	if (value === undefined) {
		return undefined;
	}

	if (typeof BmFormat.formatFunctions[mask] === "function") {
		return BmFormat.formatFunctions[mask](value);
	}

	if (mask) {
		Console.warn(`The "${mask}" mask does not exist!`);
	}
	let output = "";

	const newValue = String(value);

	if (mask && mask !== "") {
		output = newValue.replace(/\D/g, "");

		if (["év", "fő", "hónap", "hó", "db"].includes(mask)) {
			output = Number(output).toString();
		}

		output += ` ${mask}`;
	} else {
		output = newValue;
	}

	return output;
}
/**
 * Szöveg formázás, NULL és 0 esetén is undefiend
 *
 * @param  {String} value	Formázandó szöveg
 * @param  {String} mask	Formázás megnevezése
 * @return {String}			Formázott szöveg
 */
export function formatTextWhenNotZero(value: string | number | boolean, mask: string): string {
	if (value === null || value === 0 || value === "0") {
		return undefined;
	}

	return formatText(value, mask);
}
